var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37756 15.6164L2.7207 21.2733M10.6386 7.6986L11.6952 6.64194C11.7767 6.56053 11.8174 6.51983 11.8529 6.47509C11.8845 6.43534 11.913 6.39325 11.9381 6.34917C11.9665 6.29956 11.9892 6.24665 12.0345 6.14084L13.1035 3.64648C13.4154 2.91878 13.5713 2.55493 13.8233 2.38965C14.0437 2.24512 14.3122 2.19341 14.5704 2.24577C14.8658 2.30564 15.1457 2.58555 15.7055 3.14538L20.8487 8.28852C21.4085 8.84834 21.6884 9.12826 21.7483 9.4236C21.8006 9.68187 21.7489 9.95037 21.6044 10.1707C21.4391 10.4227 21.0753 10.5786 20.3476 10.8905L17.8532 11.9595C17.7474 12.0049 17.6945 12.0276 17.6449 12.0559C17.6008 12.0811 17.5587 12.1096 17.5189 12.1411C17.4742 12.1767 17.4335 12.2174 17.3521 12.2988L16.2203 13.4305M6.21144 9.26145L5.65231 9.37327C4.70001 9.56373 4.22385 9.65897 4.00109 9.91002C3.80703 10.1287 3.71841 10.4214 3.75856 10.711C3.80465 11.0435 4.14801 11.3869 4.83472 12.0736L11.9205 19.1593C12.6072 19.846 12.9505 20.1894 13.283 20.2355C13.5726 20.2756 13.8653 20.187 14.084 19.9929C14.3351 19.7702 14.4303 19.294 14.6208 18.3417L14.7549 17.671",
    stroke: "#404040",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5L21.5 21.5",
    stroke: "#404040",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnpin);
export default __webpack_public_path__ + "static/media/IconUnpin.b8c3af234e40cb257b7ada74386f1cd3.svg";
export { ForwardRef as ReactComponent };